import QRCodeStyling from "qr-code-styling";

export async function downloadStoreQr(shortId: string, storeName: string): Promise<void> {
  const url = `https://mobile.disca.app/business/sid/${shortId}`;
  const qrSize = 512;
  const padding = 56;
  const textH = 52;

  const qr = new QRCodeStyling({
    width: qrSize,
    height: qrSize,
    data: url,
    image: "/disca_logo.png",
    qrOptions: { errorCorrectionLevel: "H" },
    imageOptions: { crossOrigin: "anonymous", margin: 8, imageSize: 0.25 },
  });

  const qrBlob = await qr.getRawData("png");
  if (!qrBlob) throw new Error("QR generation failed");
  const qrBitmap = await createImageBitmap(qrBlob as Blob);

  const canvasW = qrSize + padding * 2;
  const canvasH = qrSize + padding * 2 + textH;

  const canvas = document.createElement("canvas");
  canvas.width = canvasW;
  canvas.height = canvasH;
  const ctx = canvas.getContext("2d")!;

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvasW, canvasH);
  ctx.drawImage(qrBitmap, padding, padding, qrSize, qrSize);

  ctx.fillStyle = "#E53935";
  ctx.font = "600 42px system-ui, -apple-system, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("Menu  ·  Deals  ·  Rewards", canvasW / 2, padding + qrSize + textH / 2);

  const dataUrl = canvas.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = `disca-qr-${storeName}.png`;
  a.click();
}
